import axios from "axios";

function APIService(config) {
  return axios.create(config);
}

export default APIService;
